import React from "react";
import { useParams, useOutletContext } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { removeVietnameseTones } from "../../../utils/translationHelpers";
import { normalizeLang } from "../../../utils/localeDataLoader";
import { useLeadersQuery } from "hooks";
import { getLeaderCategoryIds, normalizeLeaderPositions } from "../../../utils/leaderHelpers";

function LeaderMember() {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const { currentCategoryId, currentCategorySlug } = useOutletContext() || {};
  const currentLang = normalizeLang(i18n.language);
  const { data: leaders = [] } = useLeadersQuery(currentLang);

  let param = useParams();

  const getDisplayName = (name) =>
    currentLang !== "vi" ? removeVietnameseTones(name) : name;
  const getPrimaryRole = (leader) => normalizeLeaderPositions(leader.positions);
  const belongsToCurrentCategory = (leader) => getLeaderCategoryIds(leader).includes(Number(currentCategoryId));

  return (
    <div className="member">
      <ul className="memberlist row">
        {leaders
          .filter(belongsToCurrentCategory)
          .map((value) => (
            <div
              className="col-sm-6 col-md-3 col-lg-3 leader-card-col"
              key={value.id}
            >
              <li
                className="leader-profile-card"
                onClick={() => {
                  const basePath =
                    currentLang === "vi"
                      ? "/tong-quan/ban-lanh-dao"
                      : "/about-us/leadership";
                  const finalCategorySlug = currentCategorySlug || param.slug;
                  navigate(`${basePath}/${finalCategorySlug}/${value.slug}`);
                }}
              >
                <div className="leader-profile-card__corner" />
                <div className="leader-profile-card__photo-wrap">
                  <div className="leader-profile-card__photo-ring">
                    <img
                      src={value.image || value.img}
                      alt={t("about_menu.leadership")}
                    />
                  </div>
                </div>
                <div className="leader-profile-card__body">
                  <h4>
                    {value.education
                      ? `${value.education} ${getDisplayName(value.name)}`
                      : getDisplayName(value.name)}
                  </h4>
                  <div className="leader-profile-card__roles">
                    {getPrimaryRole(value)
                      .slice(0, 3)
                      .map((pos, idx) => {
                        const isExecutive =
                          pos === "Chủ tịch HĐQT" || pos === "Tổng Giám Đốc";

                        return (
                          <p
                            className={`role-item ${isExecutive ? "role-item--executive" : ""}`}
                            key={idx}
                          >
                            {pos}
                          </p>
                        );
                      })}
                  </div>
                </div>
              </li>
            </div>
          ))}
      </ul>
    </div>
  );
}

export default LeaderMember;
